import React from 'react';
import { observer } from 'mobx-react-lite';
import Button from 'ati-ui-react/components/Button';
import { useStores } from 'hooks/useStores';
import { ActionButton } from './RestoreButtonStyles';

const RestoreButton = observer(({ className, advert, callback }) => {
  const {
    cabinetPageStore: { restoreAd },
    advertsStore,
  } = useStores();

  const handleRestoreAd = (e) => {
    e.stopPropagation();
    advertsStore.setMiniCardAnimation(true);
    restoreAd(advert._id, callback);
  };

  return (
    <ActionButton className={className} onClick={handleRestoreAd}>
      <Button size="small" text="Восстановить">
        Восстановить
      </Button>
    </ActionButton>
  );
});

export default RestoreButton;
